import { apiClient } from '@api/client';
import type { PaymentErrorCodesResponse } from '@models/paymentErrorCodes';

export async function getAllPaymentErrorCodesPaginated(
  page: number,
  isFiltered: boolean = false,
): Promise<PaymentErrorCodesResponse> {
  const { data } = await apiClient.get<PaymentErrorCodesResponse>('/payment-provider-errors', {
    params: {
      page,
      limit: 25,
      isAttached: isFiltered,
    },
  });

  return data;
}

export async function getAllPaymentErrorCodes(
  isFiltered: boolean = false,
): Promise<PaymentErrorCodesResponse> {
  const { data } = await apiClient.get<PaymentErrorCodesResponse>('/payment-provider-errors', {
    params: {
      limit: 1000,
      isAttached: isFiltered,
    },
  });

  return data;
}
